/**
 * This file for hot reload RichText Styles config
 */
export {};
// RichText.setStyle('name', new TextStyle({}));
